import React, { useRef } from 'react';
import './App.css';
import AppRoutes from './AppRoutes';
import { FrontendComponentsThemeProvider } from 'vlab-frontend-components';
import { QueryClientProvider, QueryClient } from 'react-query';
import { AuthProvider } from './shared/auth/AuthContext';
import { FnsDateProvider } from './contexts/fnsDate';
import styled from 'styled-components';
import * as Vlab from 'vlab-frontend-components';

const queryClient = new QueryClient(); 
const StyledMaterialDesignContent = styled(
  Vlab.Notistack.MaterialDesignContent
)(() => ({
  "&.notistack-MuiContent-error": {
    backgroundColor: "#E20101",
    borderRadius: 0,
  },
}));

function App() {
  const notistackRef = useRef<any>(null);

  return (
    <QueryClientProvider client={queryClient}>
      <FrontendComponentsThemeProvider themeMode="vlab">
        <Vlab.Notistack.SnackbarProvider
          ref={notistackRef}
          iconVariant={{
            error: (
              <div style={{ marginRight: "16px" }}>
                <Vlab.InfoIcon color="white" width={24} height={24} />
              </div>
            ),
          }}
          Components={{
            error: StyledMaterialDesignContent,
          }}
          action={(key) => (
            <Vlab.ButtonIcon
              style={{ backgroundColor: "transparent" }}
              className="ignore-click-outside"
              onClick={() =>
                notistackRef.current && notistackRef.current.closeSnackbar(key)
              }
            >
              <Vlab.CloseIcon color="white" />
            </Vlab.ButtonIcon>
          )}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <FnsDateProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </FnsDateProvider>
        </Vlab.Notistack.SnackbarProvider>
      </FrontendComponentsThemeProvider>
    </QueryClientProvider>
  );
}

export default App;